import {ItemsRequest, ItemsResponse, ProductEntity} from '../../../../models/api/back/create-order/items';
import {AppThunk} from "../../../../app/store";
import {ordersDataActions} from "../../../../slices/orders/orders-data-slice";
import {apiActions} from "../../../../slices/api-slice";
import {ResponseBase} from "../../../response-base";
import {ApiBaseBack} from "../../api-base-back";
import {dialogActions} from "../../../../components/dialog/slice/dialog-slice";
import {commonActions} from "../../../../slices/common-slice";
import {ProductBlacklistResponse} from "../../../../models/api/front/product-blacklist";
import {isOlcMode} from "../../../../utilities/olc-mode";

const getHiddenProductCodes = (
  blacklist: ProductBlacklistResponse | null | undefined,
): string[] => {
  return (blacklist?.products ?? []).map((v) => v.productCode);
};

type FilterResult = ItemsResponse & { wasFilteredEmpty: boolean };

// blacklist の productCode と items の productNameId は同一識別子（jptg / jpit）
const filterHiddenProducts = (
  products: ProductEntity[],
  hiddenCodes: string[],
): FilterResult => {
  if (hiddenCodes.length === 0) {
    return { products, wasFilteredEmpty: false };
  }
  const hiddenSet = new Set(hiddenCodes);
  const filtered = products.filter((v) => !hiddenSet.has(v.productNameId));
  return {
    products: filtered,
    wasFilteredEmpty: products.length > 0 && filtered.length === 0,
  };
};

export class ApiItems extends ApiBaseBack<ItemsResponse> {
  constructor(param: ItemsRequest) {
    super(
      'GET',
      '/api/v1/products',
      'JSON',
      param,
    );
  }
}

export const apiItemsThunk = (param: ItemsRequest, callback?: () => void, isInit?: boolean): AppThunk => async (dispatch, getState) => {
  if (!param.serviceId) {
    callback?.();
    return;
  }
  // 商品取得前に、その時のモードの商品ブラックリストを確実に読み込む（後着フィルタ漏れ防止）
  await dispatch(commonActions.ensureBlacklist('product'));
  dispatch(apiActions.run(
    new ApiItems(param),
    {
      onSuccess: (res: ResponseBase<ItemsResponse>) => {
        callback?.();
        if (!isInit && getState().order.itemInfo.category.value !== param.serviceId) {
          return;
        }
        const blacklist = isOlcMode()
          ? getState().common.data.productBlacklistOlc
          : getState().common.data.productBlacklist;
        const hiddenCodes = getHiddenProductCodes(blacklist);
        const { products, wasFilteredEmpty } = filterHiddenProducts(
          res.body.data?.products || [],
          hiddenCodes,
        );
        dispatch(ordersDataActions.updateItemDetail({
          item: { products },
        }));
        // 初期ロード/編集/お気に入り読込時はユーザー操作起因でないためダイアログ抑止
        if (!isInit && wasFilteredEmpty) {
          dispatch(dialogActions.pushMessage({
            title: '確認',
            message: [
              '選択されたカテゴリに該当する商品がありません。',
              '別のカテゴリを選択してください。',
            ],
            buttons: [{
              label: 'OK',
              callback: () => dispatch(dialogActions.pop()),
            }],
          }));
        }
      },
      onError: () => {
        callback?.();
      },
    },
    {
      apiName: 'items',
      ignoreSystemError: true,
    },
  ));
};
